import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useRestApi } from "@/context/api";
import { useCurrentCompany } from "@/context/auth";
import { queryKeys } from "@/queries/queryKeys";
import { ImportAction, ImportSource, ImportStatus, ImportView } from "@/types/auth";

export interface TeamImportsQueryParams {
  page: number;
  size: number;
  view?: ImportView;
  sources?: ImportSource[];
  statuses?: ImportStatus[];
  actions?: ImportAction[];
  from?: string;
  externalId?: string;
  hideNoChange?: boolean;
  /** Only the rows one structure file import wrote */
  batchId?: string;
}

export const useTeamImportsQuery = (queryParams: TeamImportsQueryParams) => {
  const { getTeamImports } = useRestApi().teamImports;
  const currentCompany = useCurrentCompany();

  return useQuery({
    queryKey: [queryKeys.TEAM_IMPORTS, currentCompany.id, queryParams],
    queryFn: () => getTeamImports(currentCompany.id, queryParams),
    placeholderData: keepPreviousData,
    staleTime: 30000,
  });
};
